module.exports = __webpack_public_path__ + "static/media/id10-museu_coa-full.67765ccd.jpg";